import styled from 'particles/themes/styled'
import { theme } from 'theme'
export const Container = styled.div<{ show: boolean }>`
    display: ${props => (props.show ? 'flex' : 'none')};
    flex-direction: column;
    min-width: 250px;
    width: 250px;
    padding: ${theme.newSpacing.s};
    background-color: ${theme.newColors.neutral50};
    @media screen and (max-width: 768px) {
        position: absolute;
        top: 0;
        display: flex;
        left: ${props => (props.show ? '0' : '-1000px')};
        width: 100%;
        min-height: 100%;
        height: stretch;
        overflow-y: auto;
        z-index: 120;
        box-sizing: border-box;
        transition: left 0.5s;
        padding: ${theme.newSpacing.m};
    }
    .mobile-navsidebar-top {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .mobile-navsidebar-top-divider {
            height: 1px;
            width: 100%;
            background: ${theme.newColors.neutral200};
            margin: ${theme.newSpacing.m} 0;
        }
    }

    .title-block {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .steps-block {
        width: 100%;
        box-sizing: border-box;
        padding: ${theme.newSpacing.xxxs};
    }
    .steps-title-block {
        display: flex;
        align-items: center;
    }
    .options-block {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: ${theme.newSpacing.xxxs} 0;
    }
    .single-tasks-options-block {
        padding: ${theme.newSpacing.xxxs};
        .status-options {
            margin-top: ${theme.newSpacing.xxxs};
        }
    }
`
export const InfoContainer = styled.div`
    width: 208px;
    box-sizing: border-box;
`
